import { render, staticRenderFns } from "./main_contests.vue?vue&type=template&id=0b9c1583&"
import script from "./main_contests.vue?vue&type=script&lang=js&"
export * from "./main_contests.vue?vue&type=script&lang=js&"
import style0 from "./main_contests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports